import gql from 'graphql-tag';
import { Key } from '@mui/icons-material';
import { UPDATE, UPDATE_MANY } from 'react-admin';

import List from './List';
import Create from './Create';
import Edit from './Edit';
import { ResourceDefinition, ResourceSections } from 'src/types';

export const ExternalClientsResource: ResourceDefinition = {
  name: 'identity_external_clients',
  section: ResourceSections.CRAFT_IDENTITY,
  icon: Key,
  options: { label: 'External Clients' },

  list: List,
  create: Create,
  edit: Edit,

  permissions: {
    list: ['externalClient:read'],
    create: ['externalClient:edit'],
    edit: ['externalClient:edit'],
  },

  extension: {
    operations: {
      [UPDATE]: {
        operationName: 'identity_update_external_clients_by_pk',
      },
      [UPDATE_MANY]: {
        operationName: 'identity_update_external_clients',
      },
    },
    extraFields: gql`
      {
        service_roles {
          service_role {
            id
            display_name
          }
        }
      }
    `,
  },
};
